import { get } from 'lodash';
import store from '../stores/index';

export default (app) => {
    let router = app.router;

    router.beforeEach((to, from, next) => {
        let profile = store.state.profile.profile;

        let authMeta = get(to, 'meta.auth');

        if (!authMeta) {
            return next();
        }

        if (!profile.check()) {
            return next({ name: 'signIn' });
        }

        if (authMeta.includes(profile.getRole())) {
            return next();
        }

        return next({ name: 'signIn' });
    })
}
